import React, { FC, useEffect } from "react";

import { BaseComponentProps, ComponentOverrideKey } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";

import { getCustomerOverrideComponent } from "../../../lib/overrides";
import { CustomWidget as CustomWidgetModel } from "../../../models/configuration/components/customWidget";
import { WidgetUIState } from "../atoms";
import { useWidgetState } from "../hooks";
import { KWidgetProps } from "../models";

export type CustomWidgetProps = {
  widgetId: string;
} & Omit<CustomWidgetModel, "id"> &
  BaseComponentProps &
  KWidgetProps;

// Custom widget to implement specific overrides
const CustomWidget: FC<React.PropsWithChildren<CustomWidgetProps>> = function ({
  testId = "CustomWidget",
  id,
  className,
  widgetId,
  type,
}) {
  const { setWidgetState } = useWidgetState({
    id: widgetId,
    type,
  });

  useEffect(() => {
    setWidgetState({ state: WidgetUIState.RENDERED });
  }, [setWidgetState]);

  return <Box data-testid={testId} className={clsx("CustomWidget", className)} id={id} />;
};

export default getCustomerOverrideComponent<CustomWidgetProps>(
  ComponentOverrideKey.Custom,
  CustomWidget,
);
